import { mutatorAction } from 'satcheljs';
import { getActivityFeedStore } from '../store/store';

export const removeItemFromStore = mutatorAction(
    'ACTIVITY_FEED_REMOVE_ITEM_FROM_STORE',
    (itemId: string) => {
        getActivityFeedStore().items.delete(itemId);
    }
);
